import { type OpcaoPesquisavel } from './use-opcoes-pesquisaveis';

/** Uma linha da lista virtualizada: cabeçalho de grupo ou opção (com o índice entre as opções). */
export type LinhaLista =
  | { tipo: 'grupo'; rotulo: string }
  | { tipo: 'opcao'; opcao: OpcaoPesquisavel; indice: number; cabecalho: number | null };

/**
 * Intercala um cabeçalho onde o grupo muda. O teclado anda só pelas opções (`indice`); os
 * cabeçalhos ocupam linha na rolagem, por isso `linhaDaOpcao` traduz um no outro.
 */
export function linhasDaLista(opcoes: readonly OpcaoPesquisavel[]): {
  linhas: LinhaLista[];
  linhaDaOpcao: number[];
} {
  const linhas: LinhaLista[] = [];
  const linhaDaOpcao: number[] = [];
  let grupoAtual: string | undefined;
  let cabecalho: number | null = null;
  opcoes.forEach((opcao, indice) => {
    if (opcao.grupo !== grupoAtual) {
      cabecalho = opcao.grupo === undefined ? null : linhas.length;
      if (opcao.grupo !== undefined) linhas.push({ tipo: 'grupo', rotulo: opcao.grupo });
    }
    grupoAtual = opcao.grupo;
    linhaDaOpcao.push(linhas.length);
    linhas.push({ tipo: 'opcao', opcao, indice, cabecalho });
  });
  return { linhas, linhaDaOpcao };
}
